/* Cookie consent — UI layer over Shopify Customer Privacy API.
   Region gating comes free: shouldShowBanner() reflects the admin's
   "collect consent" region config. ?cb-demo=1 forces the banner for preview. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cb-root]');
  if (!root) return;

  var banner = root.querySelector('.cb-banner');
  var panel = root.querySelector('.cb-panel');
  var lastFocus = null;

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
  }

  function revealed() {
    return !root.hidden;
  }

  function reveal() {
    if (revealed()) return;
    root.hidden = false;
    window.requestAnimationFrame(function () { root.classList.add('cb-in'); });
  }

  function dismissBanner() {
    root.classList.remove('cb-in');
    window.setTimeout(function () {
      root.hidden = true;
      closePanelNow();
    }, 300);
  }

  function readToggles() {
    var state = {};
    panel.querySelectorAll('[data-cb-cat]').forEach(function (cb) {
      state[cb.getAttribute('data-cb-cat')] = cb.checked;
    });
    return state;
  }

  function prefillToggles() {
    var cp = api();
    if (!cp || typeof cp.getTrackingConsent !== 'function') return;
    try {
      var c = cp.getTrackingConsent();
      var map = { functional: 'preferences', analytics: 'analytics', marketing: 'marketing' };
      panel.querySelectorAll('[data-cb-cat]').forEach(function (cb) {
        var key = map[cb.getAttribute('data-cb-cat')];
        cb.checked = !!(key && c[key]);
      });
    } catch (e) { /* API present but region data unavailable — leave defaults */ }
  }

  function applyConsent(state) {
    var cp = api();
    if (cp && typeof cp.setTrackingConsent === 'function') {
      try {
        cp.setTrackingConsent({
          analytics: !!state.analytics,
          marketing: !!state.marketing,
          preferences: !!state.functional,
          saleOfData: !!state.marketing
        }, function () { /* consent persisted by Shopify in _tracking_consent */ });
      } catch (e) { /* store without API access — UI state still resolves locally */ }
    }
    document.dispatchEvent(new CustomEvent('cookie-banner:consent', { detail: state }));
  }

  function setAll(on) {
    panel.querySelectorAll('[data-cb-cat]').forEach(function (cb) { cb.checked = on; });
  }

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  function openPanel() {
    prefillToggles();
    lastFocus = document.activeElement;
    panel.hidden = false;
    lockScroll(true);
    window.requestAnimationFrame(function () {
      panel.classList.add('cb-open');
      panel.querySelector('.cb-close').focus();
    });
  }

  function closePanelNow() {
    panel.hidden = true;
    panel.classList.remove('cb-open');
    lockScroll(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  function closePanel() {
    panel.classList.remove('cb-open');
    window.setTimeout(closePanelNow, 180);
  }

  function decide() {
    if (revealed()) return;
    if (new URLSearchParams(window.location.search).get('cb-demo') === '1') {
      reveal();
      return;
    }
    var cp = api();
    if (cp && typeof cp.shouldShowBanner === 'function') {
      try { if (cp.shouldShowBanner()) reveal(); } catch (e) { /* region unknown */ }
    }
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-act]');
    if (!btn) return;
    var act = btn.getAttribute('data-cb-act');
    if (act === 'settings') { openPanel(); }
    else if (act === 'close') { closePanel(); }
    else if (act === 'accept') { setAll(true); applyConsent(readToggles()); dismissBanner(); }
    else if (act === 'reject') { setAll(false); applyConsent(readToggles()); dismissBanner(); }
    else if (act === 'save') { applyConsent(readToggles()); dismissBanner(); }
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cookie-preferences]');
    if (!link) return;
    e.preventDefault();
    if (root.hidden) { reveal(); }
    openPanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || panel.hidden) return;
    closePanel();
  });

  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusables = panel.querySelectorAll('button, input[type="checkbox"]:not(:disabled)');
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  var tries = 0;
  var poll = window.setInterval(function () {
    if (api() || ++tries > 40) {
      window.clearInterval(poll);
      decide();
    }
  }, 150);
  window.addEventListener('load', decide);
  document.addEventListener('DOMContentLoaded', decide);
})();
